import { render, staticRenderFns } from "./MultiSelector.vue?vue&type=template&id=b110c11c&scoped=true&"
import script from "./MultiSelector.vue?vue&type=script&lang=js&"
export * from "./MultiSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b110c11c",
  null
  
)

export default component.exports